import { NoSearchResult } from './NoSearchResult'

export const NoFilterCampaignResult = () => (
	<NoSearchResult lead='Please, change your search query or status filter to get results.' />
)
export const NoContactsFound = () => (
	<NoSearchResult lead='Please, change filters or search query to get results' />
)
